import workerAuth from "../components/worker-auth/slice/workerAuthSlice";
import workerCompliance from "../components/worker-panel/slice/workerComplianceSlice";
import workerJob from "../components/worker-panel/slice/workerJobSlice";
import workerJobs from "../components/worker-jobs/slice/workerJobsSlice";
import workerResume from "../components/worker-panel/slice/workerResumeSlice";
import workerInfo from "../components/worker-panel/slice/workerInfoSlice";
import workerDownload from "../components/worker-panel/slice/workerDownloadSlice";
import workerEditProfile from "../components/worker-panel/slice/workerEditProfile";
import workerPlansSlice from "../components/worker-panel/slice/workerPlansSlice";
import workerAllPlansSlice from "../components/worker-plans/slice/workerAllPlansSlice";
import workerDashboard from "../components/worker-panel/slice/workerDashboardSlice";
import workerShiftJob from "../components/worker-panel/slice/workerShiftAddJobSlice";
import workerShiftWorktime from "../components/worker-panel/slice/workerShiftWorktimeSlice";
import workerChildCareFacilities from "../components/worker-childCare-facilities/slice/workerChildCareFacilitiesSlice";
import workerSnapshot from "../components/worker-snapshot/slice/workerSnapshotSlice";
import workerRegister from "../components/worker-snapshot/slice/workerRegisterSlice";
import providersEmployees from "../components/worker-panel/slice/providersEmployeesSlice";
import providerBenefitsStability from "../components/worker-panel/slice/provider_benefit_stabilitySlice";

const workerRootReducer = {
    workerAuth,
    workerCompliance,
    workerJob,
    workerJobs,
    workerResume,
    workerInfo,
    workerDownload,
    workerEditProfile,
    workerPlansSlice,
    workerAllPlansSlice,
    workerDashboard,
    workerShiftJob,
    workerShiftWorktime,
    workerChildCareFacilities,
    workerSnapshot,
    workerRegister,
    providersEmployees,
    providerBenefitsStability
};

export default workerRootReducer;
